import Dashboard from "views/Dashboard.js";
import Articles from "../src/views/articles/ArticleList";
import TagList from "views/tags/TagList";
import MakesList from "views/makes/MakesList";
import MakerList from "views/makes_models/MakerList";
import EnquiryList from "views/enquiry/EnquiryList";
import ContactUsList from "views/contactUs/ContactUsList";
import FormInfoList from "views/form_info/FormInfoList";
import SliderList from "views/sliders/SliderList";
import SiteSetingList from "views/site-setting/SiteSetingList";
import CustomersList from "views/customers/CustomersList";
import PermissionsList from "views/permissions/PermissionsList";
import AdminList from "views/admins/AdminList";
import CategoryList from "views/category/CategoryList";
import ReferrelList from "views/referrelProgram/ReferrelList";
import UserOption from "views/useroptions/UserOption";
import DealerList from "views/dealers/DealerList";
import FaqList from "views/faqs/FaqList";
import TimeSlogList from "views/timeslots/TimeSlogList";
import GenderList from "views/gender/GenderList";
import AppointmentList from "views/appointments/AppointmentList";
import CategoriesList from "views/categories/CategoriesList";
import CategoryFaqList from "views/categoryFaqs/CategoryFaqList";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/admin",
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "nc-icon nc-diamond",
  //   component: Icons,
  //   layout: "/admin",
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "nc-icon nc-pin-3",
  //   component: Maps,
  //   layout: "/admin",
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "nc-icon nc-bell-55",
  //   component: Notifications,
  //   layout: "/admin",
  // },
  // {
  //   path: "/user-page",
  //   name: "User Profile",
  //   icon: "nc-icon nc-single-02",
  //   component: UserPage,
  //   layout: "/admin",
  // },
  // {
  //   path: "/customers",
  //   name: "Customers",
  //   icon: "nc-icon nc-tile-56",
  //   component: Customers,
  //   layout: "/admin",
  // },
  // {
  //   path: "/referred",
  //   name: "Reffered",
  //   icon: "nc-icon nc-tile-56",
  //   component: Reffered,
  //   layout: "/admin",
  // },
  // {
  //   path: "/completed-fixers",
  //   name: "Completed Fixers",
  //   icon: "nc-icon nc-tile-56",
  //   component: CompletedFixers,
  //   layout: "/admin",
  // },
  // {
  //   path: "/requests-fixers",
  //   name: "Requests Fixers",
  //   icon: "nc-icon nc-tile-56",
  //   component: RequestsFixers,
  //   layout: "/admin",
  // },
  // {
  //   path: "/visit-fixers",
  //   name: "Visit Fixers",
  //   icon: "nc-icon nc-tile-56",
  //   component: VisitFixers,
  //   layout: "/admin",
  // },

  // {
  //   path: "/active-riders",
  //   name: "Active Riders",
  //   icon: "nc-icon nc-tile-56",
  //   component: ActiveRiders,
  //   layout: "/admin",
  // },
  // {
  //   path: "/request-riders",
  //   name: "Request Riders",
  //   icon: "nc-icon nc-tile-56",
  //   component: ReqeustRiders,
  //   layout: "/admin",
  // },

  // {
  //   path: "/user-accounts",
  //   name: "User Accounts",
  //   icon: "nc-icon nc-tile-56",
  //   component: UserAccounts,
  //   layout: "/admin",
  // },
  {
    path: "/articles",
    name: "Articles",
    icon: "fas fa-newspaper",
    component: Articles,
    layout: "/admin",
  },

  {
    path: "/tags",
    name: "Tags",
    icon: "fas fa-tags",
    component: TagList,
    layout: "/admin",
  },

  {
    path: "/faqs",
    name: "faqs",
    icon: "fas fa-fags",
    component: FaqList,
    layout: "/admin",
  },

  {
    path: "/categoryFaqs",
    name: "categoryFaqs",
    icon: "fas fa-fags",
    component: CategoryFaqList,
    layout: "/admin",
  },

  {
    path: "/makes",
    name: "Makes",
    icon: "fas fa-car",
    component: MakesList,
    layout: "/admin",
  },

  {
    path: "/maker-models",
    name: "Models",
    icon: "fas fa-car-side",
    component: MakerList,
    layout: "/admin",
  },

  {
    path: "/enquiry",
    name: "Car Enquiry",
    icon: "fas fa-question-circle",
    component: EnquiryList,
    layout: "/admin",
  },

  {
    path: "/categories",
    name: "Categories",
    icon: "fas fa-list-alt",
    component: CategoriesList,
    layout: "/admin",
  },

  {
    path: "/genders",
    name: "genders",
    icon: "fas fa-list-alt",
    component: GenderList,
    layout: "/admin",
  },

  {
    path: "/appointments",
    name: "appointments",
    icon: "fas fa-list-alt",
    component: AppointmentList,
    layout: "/admin",
  },



  {
    path: "/timeslots",
    name: "TimeSlots",
    icon: "fas fa-list-alt",
    component: TimeSlogList,
    layout: "/admin",
  },

  {
    path: "/contact-us",
    name: "Contact Us",
    icon: "fa fa-id-badge",
    component: ContactUsList,
    layout: "/admin",
  },

  {
    path: "/form-info",
    name: "Form Infos",
    icon: "fas fa-sitemap",
    component: FormInfoList,
    layout: "/admin",
  },


  {
    path: "/user-options",
    name: "User Options",
    icon: "fas fa-sitemap",
    component: UserOption,
    layout: "/admin",
  },


  {
    path: "/sliders",
    name: "Sliders",
    icon: "fas fa-sliders-h",
    component: SliderList,
    layout: "/admin",
  },
  {
    path: "/referrels",
    name: "Referrels",
    icon: "fas fa-sliders-h",
    component: ReferrelList,
    layout: "/admin",
  },

  {
    path: "/dealers",
    name: "Dealers",
    icon: "fas fa-sliders-h",
    component: DealerList,
    layout: "/admin",
  },

  {
    path: "/site-setting",
    name: "Site Setting",
    icon: "fas fa-cogs",
    component: SiteSetingList,
    layout: "/admin",
  },

  {
    path: "/customers",
    name: "Customers",
    icon: "fa fa-user",
    component: CustomersList,
    layout: "/admin",
  },

  {
    path: "/permissions",
    name: "Permissions",
    icon: "fas fa-cogs",
    component: PermissionsList,
    layout: "/admin",
  },

  {
    path: "/admins",
    name: "Admins",
    icon: "fas fa-user",
    component: AdminList,
    layout: "/admin",
  },


  // {
  //   path: "/bookings",
  //   name: "User Bookings",
  //   icon: "nc-icon nc-tile-56",
  //   component: BookNow,
  //   layout: "/admin",
  // },
  // {
  //   path: "/contacts",
  //   name: "User Contacts",
  //   icon: "nc-icon nc-tile-56",
  //   component: Contacts,
  //   layout: "/admin",
  // },
  // {
  //   path: "/reviews",
  //   name: "User Reviews",
  //   icon: "nc-icon nc-tile-56",
  //   component: Reviews,
  //   layout: "/admin",
  // },
  // {
  //   path: "/login-page",
  //   name: "Sign In",
  //   icon: "nc-icon nc-tile-56",
  //   component: Login,
  //   layout: "/admin",
  // },

  // {
  //   path: "/typography",
  //   name: "Typography",
  //   icon: "nc-icon nc-caps-small",
  //   component: Typography,
  //   layout: "/admin",
  // },
  // {
  //   pro: true,
  //   path: "/upgrade",
  //   name: "Upgrade to PRO",
  //   icon: "nc-icon nc-spaceship",
  //   component: UpgradeToPro,
  //   layout: "/admin",
  // },
];

export default routes;
